import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { generateSitemap, generateRobotsTxt } from '../../utils/sitemapGenerator';

/**
 * SitemapPage Component
 * 
 * This component serves sitemap.xml and robots.txt files for SEO purposes.
 * It detects the requested file type from the URL and serves the appropriate content.
 */
const SitemapPage = () => {
  const location = useLocation();
  const isRobotsTxt = location.pathname.includes('robots.txt');
  
  useEffect(() => {
    const generateAndServeFile = async () => {
      try {
        // Determine which file to generate
        const content = isRobotsTxt 
          ? generateRobotsTxt() 
          : await generateSitemap();
          
        // Set the appropriate content type
        const contentType = isRobotsTxt ? 'text/plain' : 'application/xml';
        
        // Create a blob with the content
        const blob = new Blob([content], { type: contentType });
        const url = URL.createObjectURL(blob);
        
        // Download the file automatically
        const link = document.createElement('a');
        link.href = url;
        link.download = isRobotsTxt ? 'robots.txt' : 'sitemap.xml';
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error(`Error generating ${isRobotsTxt ? 'robots.txt' : 'sitemap.xml'}:`, error);
      }
    };
    
    generateAndServeFile();
  }, [isRobotsTxt]);
  
  return (
    <div style={{ display: 'none' }}>
      {/* This component doesn't render anything visible */}
    </div>
  );
};

export default SitemapPage;
